module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/discover-06cb8c27a9b0d73e4e0aae05b6546a6b.png";